import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const EmailVerificationAlertMessage = () => {
  const { t } = useTranslations(translations);

  return (
    <Text id="alert-email-verification-error-message">
      {t('alert-message-email-verification-error-message')}
    </Text>
  );
};
